/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLeading } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import API from './constants';
import { platformActions } from './slice';

const errorMessage = (error) => {
  if (error?.isTimeout || error?.isNetworkError) {
    return 'Could not confirm whether processing started. Check the server logs before retrying.';
  }
  const message = error?.data?.message ?? error?.message;
  return typeof message === 'string' ? message : 'Unable to request processing. Please try again.';
};

export function* triggerSemantic({ payload }) {
  try {
    yield call(request, API.TRIGGER_SEMANTIC, payload);
    yield put(platformActions.triggerSemanticSucceeded());
  } catch (error) {
    yield put(platformActions.triggerSemanticFailed(errorMessage(error)));
  }
}

export function* triggerNonSemantic({ payload }) {
  try {
    yield call(request, API.TRIGGER_NON_SEMANTIC, payload);
    yield put(platformActions.triggerNonSemanticSucceeded());
  } catch (error) {
    yield put(platformActions.triggerNonSemanticFailed(errorMessage(error)));
  }
}

export function* platformSaga() {
  yield takeLeading(platformActions.triggerSemantic.type, triggerSemantic);
  yield takeLeading(platformActions.triggerNonSemantic.type, triggerNonSemantic);
}
